<template>
  <div class="flex flex-col space-y-5">
    <div class="text-center">
      Cavity Insulation
    </div>

    <div class="">
      <div class="flex flex-wrap -mx-2">
        <IconButton v-if="baseWall ==='steel-frame'" :on-click="() => $emit('update:modelValue', 'yes')" :is-active="modelValue === 'yes'">
          YES
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/01-steel-batt.png" class="-mb-[25px]" />
          </template>
        </IconButton>
        <IconButton v-if="baseWall ==='steel-frame'" :on-click="() => $emit('update:modelValue', 'no')" :is-active="modelValue === 'no'">
          NO
          <template v-slot:icon>
            <img src="../../../img/wall-builder/layers/01-steel.png" class="-mb-[25px]" />
          </template>
        </IconButton>
          <IconButton v-if="baseWall ==='wood-frame'" :on-click="() => $emit('update:modelValue', 'yes')" :is-active="modelValue === 'yes'">
              YES
              <template v-slot:icon>
                  <img src="../../../img/wall-builder/layers/01-wood-batt.png" class="-mb-[25px]" />
              </template>
          </IconButton>
          <IconButton v-if="baseWall ==='wood-frame'" :on-click="() => $emit('update:modelValue', 'no')" :is-active="modelValue === 'no'">
              NO
              <template v-slot:icon>
                  <img src="../../../img/wall-builder/layers/01-wood.png" class="-mb-[25px]" />
              </template>
          </IconButton>
<!--        <IconButton :on-click="() => $emit('update:modelValue', 'spray-foam')" :is-active="modelValue === 'spray-foam'">-->
<!--          SPRAY FOAM CAVITY-->
<!--          <template v-slot:icon>-->
<!--            <img src="../../../img/wall-builder/layers/01-wood-spray.png" class="-mb-[25px]" />-->
<!--          </template>-->
<!--        </IconButton>-->
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "../components/IconButton.vue";
export default {
  data() {
    return {

    }
  },
  emits: ['update:modelValue'],
  props: {
    baseWall: String,
    modelValue: {
      type: String,
      default: null
    }
  },
  components: {
    IconButton
  }
}
</script>
